import React, { useMemo } from 'react';
import { Activity } from '@cube3/common/model/schema/resources/activities';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography/Typography';
import { ProjectActivityItem } from './ProjectActivityItem';
import { WorkspaceActivityItem } from './WorkspaceActivityItem';
import { AssetActivityItem } from './AssetActivityItem';
import { makeActivityListUI } from '../utils/makeActivityListUI';

interface ActivityProperties {
  projectActivity: Activity;
  variant: 'asset' | 'project' | 'workspace' | 'share';
  hideTargetLink?: boolean;
  onClickLink: () => void;
}
interface Properties
  extends Pick<
    ActivityProperties,
    'hideTargetLink' | 'onClickLink' | 'variant'
  > {
  title?: string;
  activities: Activity[];
}

/** Renders a group with a `title` and `ProjectActivityItem` when an array with a length greater than 0 is given */
export const ActivityGroup: React.FunctionComponent<Properties> = (props) => {
  const { title = '', variant, activities, onClickLink } = props;

  const activitiesUI = useMemo(
    () => makeActivityListUI(activities),
    [activities]
  );

  return activitiesUI.length > 0 ? (
    <>
      {title && <Typography weight="label"> {title.toUpperCase()} </Typography>}

      {activitiesUI.map((item) => {
        return item ? (
          variant === 'project' ? (
            <ProjectActivityItem activity={item} onClose={onClickLink} />
          ) : variant === 'workspace' ? (
            <WorkspaceActivityItem activity={item} onClose={onClickLink} />
          ) : (
            <AssetActivityItem activity={item} onClose={onClickLink} />
          )
        ) : null;
      })}
    </>
  ) : null;
};
